import React from 'react';
import CarCard from './CarCard';
import LoadingSpinner from './LoadingSpinner';
import { AlertCircle, Loader2 } from 'lucide-react';

const CarGrid = ({ 
  cars, 
  loading, 
  error, 
  onView, 
  onEdit, 
  onDelete, 
  onProspect, 
  readOnly = false,
  lastCarElementRef,
  isLoadingMore,
  hasMore
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
        <div className="p-4 bg-red-500/10 rounded-full mb-4">
          <AlertCircle className="w-12 h-12 text-red-400" />
        </div>
        <h3 className="text-xl font-semibold text-white mb-2">
          Error al cargar los autos
        </h3>
        <p className="text-gray-400 max-w-md">
          {error}
        </p>
      </div>
    );
  }

  if (!cars || cars.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
        <div className="p-4 bg-[#232321] rounded-full mb-4">
          <AlertCircle className="w-12 h-12 text-gray-400" />
        </div>
        <h3 className="text-xl font-semibold text-white mb-2">
          No hay autos disponibles
        </h3>
        <p className="text-gray-400">
          No se encontraron vehículos con los filtros seleccionados.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 lg:gap-6">
        {cars.map((car, index) => {
          // Agregar ref al último elemento para detectar cuando llega al final
          const isLastElement = index === cars.length - 1;
          
          return (
            <div
              key={car.id || index}
              ref={isLastElement ? lastCarElementRef : null}
              className="animate-slide-up"
              style={{ animationDelay: `${Math.min(index, 10) * 0.05}s` }}
            >
              <CarCard 
                car={car} 
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
                onProspect={onProspect}
                readOnly={readOnly}
              />
            </div>
          );
        })}
      </div>

      {/* Indicador de carga al hacer scroll */}
      {isLoadingMore && (
        <div className="flex justify-center items-center py-8 mt-8">
          <Loader2 className="w-8 h-8 text-[#7b8fa8] animate-spin" />
          <span className="ml-3 text-gray-400">Cargando más vehículos...</span>
        </div>
      )}

      {/* Mensaje cuando no hay más resultados */}
      {!loading && !isLoadingMore && !hasMore && cars.length > 0 && (
        <div className="flex justify-center items-center py-8 mt-8">
          <div className="text-center">
            <p className="text-gray-400">No hay más vehículos para mostrar</p>
            <p className="text-sm text-gray-500 mt-1">
              Total: {cars.length} vehículos
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default CarGrid;